<script setup>

</script>

<template>

  <svg class="" fill="none" height="441" viewBox="0 0 423 441" width="423" xmlns="http://www.w3.org/2000/svg">
    <g clip-path="url(#clip0_4_12)" opacity="0.1">
      <path clip-rule="evenodd"
            d="M398.385 299.009C411.711 299.009 422.509 287.829 422.509 273.795C422.509 259.76 411.711 248.818 398.385 248.818C385.06 248.818 374.032 259.998 374.032 273.795C374.032 287.591 384.83 299.009 398.385 299.009Z"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M398.385 219.797C418.833 219.797 435.145 202.67 435.145 181.737C435.145 160.804 418.603 143.677 398.385 143.677C378.167 143.677 361.396 160.804 361.396 181.737C361.396 202.67 377.937 219.797 398.385 219.797Z"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M398.385 112.277C428.253 112.277 452.606 87.0624 452.606 56.1386C452.606 25.2148 428.253 0 398.385 0C368.518 0 343.935 25.2148 343.935 56.1386C343.935 87.0624 368.288 112.277 398.385 112.277Z"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M398.845 332.55C356.341 332.55 322.108 367.993 322.108 412C322.108 456.007 356.571 491.212 398.845 491.212C441.118 491.212 475.581 455.531 475.581 412C475.581 368.469 441.118 332.55 398.845 332.55Z"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M289.254 412.238C289.254 398.441 278.456 387.261 264.901 387.261C251.346 387.261 240.777 398.441 240.777 412.238C240.777 426.035 251.575 437.215 264.901 437.215C278.226 437.215 289.254 426.035 289.254 412.238Z"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M212.748 412.238C212.748 391.067 196.206 374.178 175.988 374.178C155.77 374.178 138.998 391.305 138.998 412.238C138.998 433.171 155.54 450.298 175.988 450.298C196.436 450.298 212.748 433.171 212.748 412.238Z"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M108.671 412.238C108.671 381.314 84.318 356.099 54.2208 356.099C24.1237 356.099 0 381.314 0 412.238C0 443.162 24.3534 468.377 54.2208 468.377C84.0882 468.377 108.671 443.162 108.671 412.238Z"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M303.728 355.624C310.391 343.73 306.485 328.268 294.768 321.37C283.281 314.471 268.347 318.515 261.684 330.647C255.022 342.54 258.927 358.002 270.645 364.901C282.132 371.799 297.066 367.755 303.728 355.624Z"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M237.561 315.898C247.67 297.582 241.696 274.27 224.006 263.804C206.315 253.337 183.799 259.522 173.69 277.838C163.581 296.155 169.555 319.466 187.246 329.933C204.936 340.399 227.452 334.215 237.561 315.898Z"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M147.499 262.376C162.433 235.496 153.702 201.242 127.511 185.543C101.549 170.081 68.2355 179.358 53.3018 206C38.3681 232.88 47.0986 267.134 73.29 282.834C99.2517 298.296 132.565 289.256 147.499 262.376Z"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M343.705 314.233C355.192 307.335 359.328 292.111 352.665 279.979C346.002 268.085 331.069 263.804 319.581 270.94C308.094 277.838 303.958 293.062 310.621 305.194C317.284 317.088 332.217 321.369 343.705 314.233Z"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M305.566 245.725C323.257 235.259 329.231 211.947 319.122 193.63C309.013 175.314 286.268 169.129 268.807 179.596C251.116 190.062 245.142 213.374 255.251 231.691C265.36 250.007 288.106 256.192 305.796 245.725"
            fill="white"
            fill-rule="evenodd"/>
      <path clip-rule="evenodd"
            d="M253.413 152.716C279.375 137.254 288.335 102.762 273.402 75.8822C258.468 49.0023 225.154 39.7252 199.193 55.1871C173.231 70.649 164.271 105.141 179.204 132.021C194.138 158.901 227.452 168.178 253.413 152.478"
            fill="white"
            fill-rule="evenodd"/>
    </g>
    <defs>
      <clipPath id="clip0_4_12">
        <rect fill="white" height="824" width="797"/>
      </clipPath>
    </defs>
  </svg>


</template>

<style lang="scss" scoped>

</style>